import ModernTimeDropdown from "./modernDropdown";

const toSnakeCase = (value) => value.replace(/([A-Z])/g, "_$1").toLowerCase();
const toCamelCase = (value) => value.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
const normalizeKey = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");

// Backend may return aliases that differ from frontend field keys.
const DEFAULT_ALIAS_MAP = {
  disposition: ["customer_disposition", "conversation_disposition"],
  subdisposition: ["customer_sub_disposition", "conversation_sub_disposition"],
  concernSubcategory: ["concern_sub_category"],
  querySubcategory: ["query_sub_category"],
  customerPotential: ["customer_potential"],
  concernCategory: ["concern_category"],
  queryCategory: ["query_category"],
  openConcerns: ["open_concerns", "open_concerns_and_queries"],
};

const shouldUseMultiSelect = (multiSelectFields, fieldKey, aliasKeys = []) => {
  if (!Array.isArray(multiSelectFields) || !fieldKey) return false;
  const defaultAliases = DEFAULT_ALIAS_MAP[fieldKey] || [];
  const candidates = [
    fieldKey,
    toSnakeCase(fieldKey),
    toCamelCase(fieldKey),
    ...defaultAliases,
    ...aliasKeys
  ].filter(Boolean);
  const normalizedFieldSet = new Set(multiSelectFields.map(normalizeKey));
  return candidates.some((candidate) => normalizedFieldSet.has(normalizeKey(candidate)));
};

export default function AdvancedFilterDropdown({
  multiSelectFields = [],
  fieldKey,
  aliasKeys = [],
  ...props
}) {
  const isMultiSelect = shouldUseMultiSelect(multiSelectFields, fieldKey, aliasKeys);
  return (
    <ModernTimeDropdown
      {...props}
      isMulti={isMultiSelect}
      showBulkActions={isMultiSelect}
    />
  );
}
